import type { ApiData, Metadata } from './types';
import type { RouteParams } from 'nextjs/types';

import type { Route } from 'nextjs-routes';

import config from 'configs/app';
import getNetworkTitle from 'lib/networks/getNetworkTitle';
import { NOINDEX_ROUTES } from 'lib/seo/indexableRoutes';
import { buildWebsiteJsonLd } from 'lib/seo/jsonLd';
import { currencyUnits } from 'lib/units';

import compileValue from './compileValue';
import getCanonicalUrl from './getCanonicalUrl';
import * as templates from './templates';

export default function generate<Pathname extends Route['pathname']>(route: RouteParams<Pathname>, apiData: ApiData<Pathname> = null): Metadata {
  const params = {
    ...route.query,
    ...apiData,
    network_name: config.chain.name,
    network_title: getNetworkTitle(),
    network_gwei: currencyUnits.gwei,
  };

  const title = compileValue(templates.title.make(route.pathname, Boolean(apiData)), params);
  const description = compileValue(templates.description.make(route.pathname, Boolean(apiData)), params);
  const canonical = getCanonicalUrl(route.pathname, route.query as Record<string, string | Array<string> | undefined> | undefined);
  const ogUrl = canonical ?? (route.pathname === '/' ? config.app.baseUrl : undefined);

  return {
    title,
    description,
    opengraph: {
      title,
      description,
      imageUrl: config.meta.og.imageUrl,
      url: ogUrl,
    },
    canonical,
    robots: NOINDEX_ROUTES.includes(route.pathname) ? 'noindex, nofollow' : undefined,
    jsonLd: route.pathname === '/' ? buildWebsiteJsonLd() : undefined,
  };
}
